import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import RiegosDiagnosticosTabla from './RiegosDiagnosticosTabla.jsx';

const RiegosDiagnosticosListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Diagnóstico Inicial de Riego</Link></li>
        <li className="breadcrumb-item active">Listado de diagnósticos</li>
      </ol>
      <h1 className="page-header">Diagnóstico Inicial de Riego <small></small></h1>
      <Panel>
        <PanelHeader>Listado de diagnósticos</PanelHeader>
        <PanelBody>
            <RiegosDiagnosticosTabla/>
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default RiegosDiagnosticosListar;
